import { motion } from "motion/react";

const sizeVariants = {
  sm: { container: "ui-gap-0.5", dot: "ui-w-1 ui-h-1" },
  md: { container: "ui-gap-1", dot: "ui-w-1.5 ui-h-1.5" },
};

export interface DotsLoaderProps {
  color?: string;
  size?: keyof typeof sizeVariants;
}

/**
 * Three pulsing dots — the loading state the checkout CTA has always used. Lives here so
 * `PrimaryButton` stays self-contained inside the package.
 */
const DotsLoader = ({ color, size = "md" }: DotsLoaderProps = {}) => {
  const dots = [0, 1, 2];
  const { container, dot } = sizeVariants[size];
  return (
    <div className={`ui-flex ${container} ui-items-center ui-justify-center`}>
      {dots.map((i) => (
        <motion.div
          key={i}
          className={`${dot} ui-rounded-full`}
          style={{ backgroundColor: color ?? "#ffffff" }}
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: i * 0.2,
            ease: "easeOut",
          }}
        />
      ))}
    </div>
  );
};

export default DotsLoader;
